import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";
import AppReducer from './App/AppSlice';

const rootReducer = (history) => 
combineReducers({
    router: connectRouter(history),
    app: AppReducer
})

export default rootReducer;